import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';

import ProductsRoutes from './routes/ProductsRoutes'
import AboutUsRoutes from './routes/AboutUsRoutes'
import ContactRoutes from './routes/ContactRoutes'
import NotFound from './pages/notfound/NotFound';
import Home from './pages/home/Home';
import LoginRoutes from './routes/LoginPage';
import RegisterPage from './routes/RegisterPage';

import AppRoutes from './routes/AppRoutes'
import PassRecoverPage from './routes/PassRecoverPage'
import FaqPage from './routes/FaqPage'
import CalculadoraFR from './pages/frcalculator/CalculadoraFR';

/*
<Route path='adminpanel/*' element={<AdminPanelPage />} />
*/

const root = ReactDOM.createRoot(document.getElementById('nicolini-refrigeracion'));
root.render(
  <BrowserRouter>
    <Routes>
        <Route path="/" element={<Home/>} />
        <Route path='*' element={<NotFound />} />
        
        <Route path="productos/*" element={<ProductsRoutes />} />
        <Route path="nosotros/*" element={<AboutUsRoutes />} />
        <Route path="contacto/*" element={<ContactRoutes />} />
        <Route path="register/*" element={<RegisterPage />} />
        <Route path="login" element={<LoginRoutes />} />
        <Route path="faq" element={<FaqPage />} />
        <Route path="calculadora-aire-acondicionado" element={<CalculadoraFR />} />

        
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
